import * as React from "react"
import { FaFacebook, FaInstagram, FaLinkedin, FaTwitter } from "react-icons/fa"

import { IFooterLink } from "../shell/Footer/Footer"

export interface LinkGroup {
  title: string
  links: Array<{
    label: string
    href: string
    badge?: React.ReactElement
  }>
}

export const links: LinkGroup[] = [
  {
    title: "Company",
    links: [{ label: "Niftory", href: "#" }],
  },
  {
    title: "Product",
    links: [{ label: "Contact Us", href: "#" }],
  },
  {
    title: "Resources",
    links: [{ label: "Built On Flow", href: "https://www.onflow.org/" }],
  },
  {
    title: "Contact",
    links: [{ label: "Contact Us", href: "#" }],
  },
]

interface SocialLink {
  label: string
  icon: React.ReactElement
  href: string
}

export const socialLinks: SocialLink[] = [
  { label: "Facebook", icon: <FaFacebook />, href: "#" },
  { label: "Instagram", icon: <FaInstagram />, href: "#" },
  { label: "LinkedIn", icon: <FaLinkedin />, href: "#" },
  { label: "LinkedIn", icon: <FaTwitter />, href: "#" },
]

export const footerLinks: IFooterLink[] = [
  { label: "Terms of Service", href: "/tos" },
  { label: "Privacy Policy", href: "/privacy" },
  { label: "Built on Flow", href: "https://www.onflow.org/" },
]
